import React from 'react'
import Header from './Header'
import CoinFlipper from './CoinFlipper/CoinFlipper'
import Logo from '../Assets/raffle.png'
import Countdown from 'react-countdown';
import './Coin/Coin.css'
import icon from '../Assets/favicon.png'

const Coinflip = () => {
    console.log(Date.now())
    return (
        <div className='bg-gray-800'>
            <Header />
            <div className='w-full h-[90vh] flex  justify-center px-10 '>
                <div className='flex-col items-center justify-center text-center '>
                    <img src={Logo} className="w-[500px]" />
                    <p className='arcade text-white text-[1rem]'>We will take a snapshot of delist raffles in: <Countdown date={1659287131723 + 32000000} /> </p>
                    <p className='mt-10 text-red-500'>Delist and Sweep if you want to earn<br></br> one of the 3 prizes in every snapshot!</p>
                </div>
                <div className='arcade gap-20 justify-center flex flex-col items-center' >
                    <p className='text-[0.8rem] flex text-cyan-300'>Next prize: 10 sol => 3 winners </p>

                    <p className='text-[0.8rem] flex text-yellow-500'>Current VOL: 100 SOL</p>
                    <p className='text-[0.8rem] flex text-yellow-500'>EXAMPLE OF OUR RAFFLES</p>
                    <table className="table-auto text-white text-[0.8rem] ">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>PRIZE</th>
                                <th>WINNER</th>
                                <th>DATE</th>
                                <th>STATE</th>
                                <th>TX</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className='' >
                                <td className='px-4'>#1</td>
                                <td className='px-4'>3.33 SOL</td>
                                <td className='px-4'>47vxuuGFri6oJo2..</td>
                                <td className='px-4'>30/07/22</td>
                                <td className='text-green-200 p-2'>SENDED</td>
                                <td><img className='w-4' src={icon} /></td>
                            </tr>
                            <tr className='' >
                                <td className='px-4'>#2</td>
                                <td className='px-4'>3.33 SOL</td>
                                <td className='px-4'>47vxuuGFri6oJo2..</td>
                                <td className='px-4'>30/07/22</td>
                                <td className='text-green-200 p-2'>SENDED</td>
                                <td><img className='w-4' src={icon} /></td>
                            </tr>
                            <tr className='' >
                                <td className='px-4'>#3</td>
                                <td className='px-4'>3.33 SOL</td>
                                <td className='px-4'>47vxuuGFri6oJo2..</td>
                                <td className='px-4'>30/07/22</td>
                                <td className='text-green-200 p-2'>SENDED</td>
                                <td><img className='w-4' src={icon} /></td>
                            </tr>




                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default Coinflip